import BasicResource from '@/api/resource';

class BannerFoldersResource extends BasicResource {

    constructor () {
        super('banner-folders');
    }

}

export default new BannerFoldersResource;
